import {makeStyles} from '@material-ui/core'
const BOX_SIZE = 35

const useStyles = makeStyles(theme => ({
  root: {
    width: `calc(${BOX_SIZE}rem + 0.125rem)`, // 2px for borders = 0.125rem
    height: `calc(${BOX_SIZE}rem + 0.125rem)`, // 2px for borders = 0.125rem
    overflow: 'hidden',
    boxSizing: 'content-box',
    padding: '30px',
    border: '1px solid #cacaca',
    borderRadius: 10,
    margin: 'auto',
  },
  cardRow: {
    borderRadius: 10,
    border: 1,
    borderColor: '#cacaca',
    borderStyle: 'solid',
    display: 'inline-block',
    boxShadow: 'none',
    background: '#F5F5F5',
    padding: 0,
  },
  cardRowBtn: {
    borderRadius: 10,
    border: 1,
    borderStyle: 'solid',
    display: 'inline-block',
    boxShadow: 'none',
    background: '#F5F5F5',
    borderColor: 'LightGray',
    outline: 'none',
    padding: '0px',
  },
}))

export default useStyles
